function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var core = {
  elizabeth: "#009623",
  "queen-elizabeth": "#009623",
  kate: "#ffb400",
  "princess-kate": "#ffb400",
  white: "#ffffff",
  doc: "#444444"
};
export var lights = {
  sneezy: "#eee",
  sleepy: "#ddd",
  happy: "#ccc"
};
export var darks = {
  grumpy: "#888",
  dopey: "#666",
  bashful: "#222"
};
export var highlights = {
  harry: "#26b11b",
  "prince-harry": "#26b11b",
  malcolm: "#00abcc",
  malcom: "#00abcc",
  peter: "#7e3e97",
  julia: "#E74C3C"
};
export var functional = {
  kevin: "#94040c"
};
export var greens = {
  william: "#008a20",
  "prince-william": "#008a20",
  charles: "#0a6d12",
  "prince-charles": "#0a6d12",
  philip: "#005b11",
  "prince-philip": "#005b11"
};
export var blues = {
  tony: "#0067b6",
  john: "#18659f",
  harold: "#005487"
};
export var purples = {
  quentin: "#68367f",
  ninian: "#602f73",
  zelman: "#552c68"
};
export var hospitalTiers = {
  basic: greens.william,
  bronze: "#cd7f32",
  silver: "#83aebe",
  gold: "#c5b358"
};
export var theCheckUp = {
  active: "#dde224",
  future: "#3d5afe",
  health: "#ff5722",
  community: "#1de9b6"
};
export var foundation = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, core), lights), darks), highlights), functional);
export var product = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, greens), blues), purples), hospitalTiers);

var colors = _objectSpread(_objectSpread(_objectSpread({}, foundation), product), theCheckUp);

export default colors;